// Decides whether black or white text will be easier to read on top of a given hex color.
// It checks the background brightness and uses black for light colors, white for dark ones.
export function getContrastingColor(backgroundColor: string): "black" | "white" {
  if (!backgroundColor.startsWith("#")) {
    console.warn(
      `getContrastingColor expected a hex color starting with #, but received "${backgroundColor}".`
    );
    return "black";
  }

  const hex = backgroundColor.slice(1, 7);
  const red = Number.parseInt(hex.slice(0, 2), 16);
  const green = Number.parseInt(hex.slice(2, 4), 16);
  const blue = Number.parseInt(hex.slice(4, 6), 16);

  // Perceived brightness (luma-like) where green contributes most to human vision.
  const brightness = (red * 299 + green * 587 + blue * 114) / 1000;
  // 160 is the readability cutoff: lighter backgrounds get black text, darker get white.
  return brightness >= 160 ? "black" : "white";
}
